export default "__VITE_ASSET__3f56758f__"